/**
 * Comprobante de gasto — ticket de 77mm, equivalente web de
 * procedimiento.imprimirgasto del escritorio (impresión RAW a la térmica).
 *
 * Mismos campos y el mismo pie "Recibido Por" que el escritorio: ares5510
 * lo imprime al registrar el gasto y ares5520 lo reimprime por fila.
 *
 * Un gasto anulado (valor 0) no se imprime: en el escritorio el botón de
 * reimprimir queda deshabilitado en esas filas.
 */
import { imprimirReciboPdf } from "lib/recibopdf";

const aNumero = (v) => {
  const n = typeof v === "number" ? v : parseFloat(String(v ?? "").replace(/,/g, ""));
  return Number.isNaN(n) ? 0 : n;
};

/**
 * @param {Object} gasto  Fila de gastos: {id, fecha, tipogastos, descripcion,
 *                        referencia, valor, sucursal, user}. Acepta el `valor`
 *                        ya formateado ("1,500.00") que devuelve el listado.
 * @param {Object|string} [compania]  Membrete; por defecto el nombre del negocio.
 */
export function imprimirComprobanteGasto(gasto, compania) {
  const g = gasto || {};
  imprimirReciboPdf({
    titulo: "Registro de Gasto",
    compania: compania || localStorage.getItem("nombrenegocio") || "",
    campos: [
      ["Gasto #", g.id],
      ["Fecha", g.fecha],
      ["Tipo Gasto", g.tipogastos],
      ["Descripción", g.descripcion],
      ["Referencia", g.referencia],
      ["Sucursal", g.sucursal],
      ["Registrado por", g.user],
    ],
    totales: [{ etiqueta: "Valor", valor: aNumero(g.valor), destacado: true }],
    firma: "Recibido Por",
  });
}

export default imprimirComprobanteGasto;
